import { Navigate, Outlet } from "react-router-dom"
import Sidebar from "@/components/Sidebar"
import { useUser } from "@/hooks/useUser"
import Header from "@/components/Header"
import { operatorPascaNavigations } from "@/constants"

export default function OperatorPascaLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const operatorPasca = userRoles.includes("operator_pasca") || false

  if (!isPending && !operatorPasca) return <Navigate to={"/"} />

  return (
    <main className="flex">
      <Sidebar navigationMenus={operatorPascaNavigations} />
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  )
}
